import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
export function RepaymentTab() {
  const [repaymentFrequency, setRepaymentFrequency] = useState('');
  return <div className="space-y-6 max-w-2xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-865">
      <Select label="Repayment Frequency" value={repaymentFrequency} onChange={e => setRepaymentFrequency(e.target.value)} options={[{
      value: '',
      label: 'Select frequency...'
    }, {
      value: 'daily',
      label: 'Daily'
    }, {
      value: 'weekly',
      label: 'Weekly'
    }, {
      value: 'monthly',
      label: 'Monthly'
    }, {
      value: 'end_of_tenor',
      label: 'End of Tenor'
    }]} data-id="element-866" />

      <Input type="number" label="Repayment Due" placeholder="e.g. 1" min="1" max="31" data-id="element-867" />
      <p className="text-xs text-gray-500 -mt-4" data-id="element-868">
        Day of the month when repayment is due (1-31)
      </p>

      <Input type="number" label="Repayment Overdue" placeholder="e.g. 5" min="1" data-id="element-869" />
      <p className="text-xs text-gray-500 -mt-4" data-id="element-870">
        Number of days after due date before marking as overdue
      </p>

      <Input type="number" label="Default After (Days)" placeholder="e.g. 90" min="1" data-id="element-871" />

      <div className="bg-blue-50 p-4 rounded-md border border-blue-100" data-id="element-872">
        <h4 className="text-sm font-semibold text-blue-800 mb-2" data-id="element-873">
          Repayment Configuration
        </h4>
        <ul className="text-sm text-blue-600 space-y-1" data-id="element-874">
          <li data-id="element-875">
            • <strong data-id="element-876">Frequency:</strong> How often repayments are collected
          </li>
          <li data-id="element-877">
            • <strong data-id="element-878">Repayment Due:</strong> Specific day of the month for
            repayments
          </li>
          <li data-id="element-879">
            • <strong data-id="element-880">Overdue:</strong> Days after due date to flag as overdue
          </li>
          <li data-id="element-881">
            • <strong data-id="element-882">Default After:</strong> Days after which the loan defaults
          </li>
        </ul>
      </div>
    </div>;
}